import { render } from "./GuidedTour.vue?vue&type=template&id=17324812&scoped=true"
import script from "./GuidedTour.vue?vue&type=script&lang=js"
export * from "./GuidedTour.vue?vue&type=script&lang=js"

import "./GuidedTour.vue?vue&type=style&index=0&id=17324812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17324812"]])

export default __exports__